import SmartLink from './SmartLink'

export default SmartLink
